export const FeaturesEnum = {
  BEE2LINK: 'BEE2LINK',
  BODYWORK_APPOINTMENT: 'BODYWORK_APPOINTMENT',
  CAR_CONFIGURATOR: 'CAR_CONFIGURATOR',
  CLIPPING: 'CLIPPING',
  IMAGE_INSIDE_360: 'IMAGE_INSIDE_360',
  LEAD: 'LEAD',
  LOCKER_BOOKING: 'LOCKER_BOOKING',
  MULTIPLE_PAYERS: 'MULTIPLE_PAYERS',
  MOBILITY: 'MOBILITY',
  ONLINE_PAYMENT: 'ONLINE_PAYMENT',
  OPEN_FLEX: 'OPEN_FLEX',
  PLANET_VO: 'PLANET_VO',
  PARTS_REMINDER: 'PARTS_REMINDER',
  PHONE_AGENT: 'PHONE_AGENT',
  REMINDER: 'REMINDER',
  SELF_SERVICE_CHECK_IN_DOCUMENTS: 'SELF_SERVICE_CHECK_IN_DOCUMENTS',
  SELF_SERVICE_CHECK_OUT_DOCUMENTS: 'SELF_SERVICE_CHECK_OUT_DOCUMENTS',
  SELF_SERVICE_EXTRAS: 'SELF_SERVICE_EXTRAS',
  SELF_SERVICE_QUESTIONS: 'SELF_SERVICE_QUESTIONS',
  VIDEO_360: 'VIDEO_360',
  WHITE_LISTED_PLATES: 'WHITE_LISTED_PLATES',
  AUTOMATED_DOCUMENT_VALIDATION: 'AUTOMATED_DOCUMENT_VALIDATION'
} as const;

export type FeaturesEnum = typeof FeaturesEnum[keyof typeof FeaturesEnum];
